//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('shipmentContainer', {
//        templateUrl: 'views/components/views/shipmentContainer/shipmentContainer.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'translateService', 'shipmentContainerService', 'rememberService', function ($stateParams, stateService, utilityService, modalService, translateService, shipmentContainerService, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let shipmentContainerKeyno = $stateParams.shipmentcontainer_keyno;

//            let variableNames = {
//                stocklocation_keyno: ''
//            };

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                selectListStockLocations: [],
//                itemsListContents: [],
//                lockedCreate: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await shipmentContainerService.getEdit({ shipmentcontainer_keyno: shipmentContainerKeyno }))[0];
//            }

//            async function loadStockLocations() {
//                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_to) !== true) return;
                
//                return vm.model.selectListStockLocations = await shipmentContainerService.listStockLocations({
//                    stockzoneclass_keyno: '1',
//                    stockplace_id: vm.model.edit.stockplace_id_to,
//                    add_all: '0'
//                });
//            }
            
//            async function loadContents() {
//                if (utilityService.validateParmsValue(vm.model.edit.shipmentcontainer_keyno) !== true) return;

//                return vm.model.itemsListContents = await shipmentContainerService.listContents({ shipmentcontainer_keyno: vm.model.edit.shipmentcontainer_keyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'stocklocation_keyno':
//                            variableNames[key] = 'w_shipmentcontainer.stocklocation_keyno.stockplaceid=' + vm.model.edit.stockplace_id_to;
//                            break;
//                        default:
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'stocklocation_keyno':
//                        if (utilityService.validateParmsValue(vm.model.edit[id], true) !== true) return;

//                        variableValue = vm.model.edit[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreate = true;

//                shipmentContainerService.createObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedCreate = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedCreate = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'stocklocation_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.edit.stocklocation_keyno) !== true) return;

//                        vm.model.edit.stocklocation_keyno = value;

//                        if (utilityService.validateParmsValue(vm.model.edit.stocklocation_keyno) !== true) return;

//                        rememberFunc('stocklocation_keyno');
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadEdit();
//                loadStockLocations();
//                loadContents();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
